
import TimeUtils from "../helper/TimeUtils";
import ZeroTimeUtils from "../helper/ZeroTimeUtils";


class ZeroTimeTool {

    constructor(_dataObjSeconds,_playerSeconds) {
        //this.init();

        this.DataObjSeconds = 0; //
        this.PlayerSeconds = 0; //扣掉ZeroTime

        this.DataObjSeconds = _dataObjSeconds;
        this.PlayerSeconds = _playerSeconds;

        this.init = function () {
            // Initialization code here.
        }

        this.init();
    }

    getPlayerRightTime(){
        //資料秒數扣掉 Zero time
        return this.DataObjSeconds - ZeroTimeUtils.getZerotimeSeconds();
    }

    convertPlayerTimeToDataObjSeconds(){
        //資料秒數扣掉 Zero time
        return this.PlayerSeconds + ZeroTimeUtils.getZerotimeSeconds();
    }

    //撥放器字幕
    getTimeDisplayRef_Text(totalPlayTime){
 
       return `${TimeUtils.convertSecondToTimeString((this.PlayerSeconds + ZeroTimeUtils.getZerotimeSeconds()) ,TimeUtils.getFPS())} / ${totalPlayTime}`;
    }
}

export default ZeroTimeTool;



// WEBPACK FOOTER //
// ./src/class/ZeroTool.js